<ion-app>
  <ion-split-pane contentId="main-content">
    <ion-menu contentId="main-content" type="overlay" id="menuprincipale">
      <ion-content>

        <ion-list id="main-nav" *ngIf="!!loggedUser">

          <ion-list-header>
            <img src="/assets/icon/confra.jpg" width="100px">
            Gestione Confraternita
          </ion-list-header>

          <ion-item>
            <img src="/assets/icon/user.png" width="50px">
            <strong>Benvenuto:</strong>&nbsp;{{ loggedUser.name }}
          </ion-item>

          <ion-button size="small" expand="full" (click)="logout()" class="ion-margin-bottom" >
            <ion-icon slot="start" name="exit"></ion-icon>
            <ion-label>Esci</ion-label>
          </ion-button>

          <ion-select [value]="cappella" (ionChange)="cappellaChange($event)">
            <ion-select-option *ngFor="let cap of cappelle" [value]="cap.key">
              <ion-label>
                {{ cap.label }}
              </ion-label>
            </ion-select-option>
          </ion-select>

          <ng-container *ngFor="let p of appPages; let i = index">
            <ion-menu-toggle *ngIf="p.hide === false" auto-hide="false">
              <ion-item routerDirection="root" [routerLink]="[p.url]" lines="none" detail="false" routerLinkActive="selected">
                <ion-icon slot="start" [ios]="p.icon + '-outline'" [md]="p.icon + '-sharp'"></ion-icon>
                <ion-label>{{ p.title }}</ion-label>
              </ion-item>
            </ion-menu-toggle>
          </ng-container>

        </ion-list>

      </ion-content>
    </ion-menu>
    <ion-router-outlet id="main-content"></ion-router-outlet>
  </ion-split-pane>
</ion-app>
